var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_78_40",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 98
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#F3F4F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_78_40)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.3984,
    y: 60.5312,
    width: 61.2076,
    height: 68.4559,
    rx: 30.6038,
    fill: "#B3BAC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7031 33.1457C31.7031 23.5944 39.446 15.8516 48.9972 15.8516V15.8516C58.5485 15.8516 66.2914 23.5944 66.2914 33.1457V41.023C66.2914 48.2136 60.4622 54.0427 53.2716 54.0427H44.7228C37.5322 54.0427 31.7031 48.2136 31.7031 41.023V33.1457Z",
    fill: "#B3BAC2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/defaultProfile.11514ec1cdd544a4afb03643e46fd5cd.svg";
export { ForwardRef as ReactComponent };